module.exports = __webpack_public_path__ + "img/icon_cat.7bdad881.png";